import { FunctionComponent, useEffect } from 'react';
import { Card, useForm } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Title } from 'UI';
import { Box } from 'vopay';
import { useConvertMyTemplateFormFields, type ConvertMyTemplateFormValues } from './useConvertMyTemplateFormFields';

type ConvertMyTemplateFormProps = {
  onSubmit: (values: ConvertMyTemplateFormValues) => void;
  onValidate: (isValid: boolean) => void;
  isReviewing?: boolean;
  defaultValues?: Partial<ConvertMyTemplateFormValues>;
};

type FC = FunctionComponent<ConvertMyTemplateFormProps>;

const ConvertMyTemplateFormValues: FC = ({ onSubmit, onValidate, defaultValues = {}, isReviewing = false }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'FileUpload.FileUploadDrawer.ConvertTemplate' });

  const { uploadFile, preprocessingConfigsLoading } = useConvertMyTemplateFormFields();

  const initialValues: ConvertMyTemplateFormValues = {
    Service: '',
    FileBase64: '',
    FileName: '',
    PaymentRail: '',
    ValueDate: new Date().getTime().toString(),
    FileConversionConfigurationID: '',
    FileConversionPreprocessingID: '',
    ...defaultValues,
  };

  const { renderFormElements, ctx } = useForm<ConvertMyTemplateFormValues>({
    initialValues,
    config: uploadFile,
    isReviewing,
    onSubmit: (values, ctx) => {
      onSubmit({
        ...values,
        FileName: ctx.values.FileName,
        FileBase64: ctx.values.FileBase64,
        FileConversionPreprocessingID: ctx.values.FileConversionPreprocessingID,
      });
    },
  });

  useEffect(() => {
    onValidate(ctx.isValid && !preprocessingConfigsLoading);
  }, [ctx, preprocessingConfigsLoading]);

  return (
    <form onSubmit={ctx.handleSubmit} id="fileUploadForm">
      <Box flx="col" gap="md">
        <Card>
          <Box flx="col" gap="md">
            <Title level="5">{t('uploadFile')}</Title>
            {renderFormElements({ config: uploadFile })}
          </Box>
        </Card>
      </Box>
    </form>
  );
};

export default ConvertMyTemplateFormValues;
